<template>
  <div class="contribute-tab">
    <div
      class="tab-item"
      v-for="(item, index) in tabList"
      :class="{ select: index == current }"
      @click="
        (_) => {
          !index ? $emit('changeTab', index) : $router.push('contact-online');
        }
      "
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ContributeTab",
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabList: [{ name: "无偿投稿" }, { name: "有偿投稿" }],
    };
  },
};
</script>

<style lang="scss" scoped>
.contribute-tab {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .tab-item {
    font-size: 22px;
    font-weight: 400;
    color: #555555;
    user-select: none;
    box-sizing: border-box;
    height: 50px;
    line-height: 50px;
  }
  .tab-item:nth-child(2) {
    margin-left: 5%;
  }
  .select {
    color: #0054f7;
    border-bottom: 5px solid #0054f7;
    transition: 0.1s all;
  }
}
</style>
